<template>
  <v-row class="mt_dec--30">
    <!-- Start Blog Area  -->
    <v-col
      lg="4"
      md="4"
      sm="6"
      cols="12"
      v-for="(item, i) in blogContent"
      :key="i"
    >
      <div class="im_box mt--30">
        <div class="thumbnail">
          <router-link :to="'/blog-details/' + item.slug">
            <img class="w-100" :src="item.src" alt="Blog Images" />
          </router-link>
        </div>
        <div class="content">
          <div class="inner">
            <div class="content_heading">
              <div class="category_list">
                <router-link :to="'/blog-details/' + item.slug">{{
                  item.category
                }}</router-link>
              </div>
              <h4 class="heading-title">
                <router-link :to="'/blog-details/' + item.slug">{{ item.title }}</router-link>
              </h4>
            </div>
            <div class="content_footer">
              <router-link :to="'/blog-details/' + item.slug" class="rn-btn btn-opacity">
                Leia mais
              </router-link>
            </div>
          </div>
          <router-link
            class="transparent_link"
            :to="'/blog-details/' + item.slug"
          ></router-link>
        </div>
      </div>
    </v-col>
    <!-- End Blog Area  -->
  </v-row>
</template>

<script>
  export default {
    data() {
      return {
        blogContent: [],
      };
    },
    async mounted() {
      try {
        const res = await fetch("/content/blog/posts.json");
        const posts = await res.json();
        this.blogContent = (Array.isArray(posts) ? posts : []).map((p) => ({
          src: p.thumbnail,
          title: p.title,
          category: p.category,
          slug: p.slug,
        }));
      } catch (e) {
        this.blogContent = [];
      }
    },
  };
</script>
